import React from "react";
import PriceTypeGenericSkeleton from "./PriceTypeGenericSkeleton";

function PriceTypeDetailSkeleton() {
  return (
    <>
      <PriceTypeGenericSkeleton />
    </>
  );
}

export default PriceTypeDetailSkeleton;
